export const roundPixel = (num) =>
  Math.round((num + Number.EPSILON) * 100) / 100;

export const escapeSpecialSymbols = (text) =>
  text.replace(/&#39;/g, "'").replace(/&amp;/g, '&');

export default roundPixel;
